// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uzJWi","search":"styles_search__3kH6h"};